import React, { useRef } from 'react';
import { useDialog } from '../../utils/useDialog';

export interface PopupDialogProps {
  /** Accessible label for the dialog */
  ariaLabel: string;
  /** Called when the dialog should close (Escape, outside click, close button) */
  onClose: () => void;
  /** Refs to elements that should not trigger outside-click dismissal (e.g. trigger buttons) */
  ignoreRefs?: React.RefObject<HTMLElement | null>[];
  /** Content to render inside the dialog body */
  children: React.ReactNode;
}

/**
 * Accessible modal dialog with focus trap, Escape-to-close, and outside-click dismissal.
 * Renders a full-screen overlay with a centered content container.
 */
export const PopupDialog: React.FC<PopupDialogProps> = ({ ariaLabel, onClose, ignoreRefs, children }) => {
  const closeBtnRef = useRef<HTMLButtonElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  useDialog({
    containerRef: popupRef,
    onEscape: onClose,
    onOutsideClick: onClose,
    outsideClickIgnoreRefs: ignoreRefs,
    initialFocusRef: closeBtnRef,
  });

  return (
    <div className="poly-page-footer__popup-overlay">
      <div className="poly-page-footer__popup-container" ref={popupRef} role="dialog" aria-modal="true" aria-label={ariaLabel}>
        <button type="button" className="poly-page-footer__popup-close" ref={closeBtnRef} onClick={onClose} aria-label="Close">✕</button>
        <div className="poly-page-footer__popup">
          {children}
        </div>
      </div>
    </div>
  );
};
